import { getOrThrow } from 'quartz-core-utils/globalState/api';
import { COPILOT_LAYOUT_TYPE } from '../frameworkInternal/tools/copilot/copilot';
/**
 * Returns the name of the current package.
 *
 * @example
 * ```ts
 * import { getCopilotLayoutType } from 'quartz-core/framework/copilot';
 *
 * console.log(getCopilotLayoutType()); // 'sidebar'
 * ```
 */
export const getCopilotLayoutType = () => getOrThrow(COPILOT_LAYOUT_TYPE);